import React, { useRef, useState, useEffect } from 
'react';
import axios from 'axios';
import { Button, Typography, Box, IconButton, Modal, Grid2 } from "@mui/material";
import Grid from '@mui/material/Grid2';
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import especialidadeCard from "../Components/especialidadeCard";
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import InstagramIcon from '@mui/icons-material/Instagram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EspecialidadeCard from "../Components/especialidadeCard";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Agendar from '../Components/Agendar';
import { useParams, useNavigate } from 'react-router-dom';
import StarRoundedIcon from '@mui/icons-material/StarRounded';

const Home = () => {    
    const [posts, setPosts] = useState([]);
    const [servicos, setServicos] = useState([]);
    const {servicoName} = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        async function fetchPosts() {
          try {
            const response = await axios.get("https://api.sigmasystems.com.br/api/odontoluzzi/instagram", {
              params: { limit: 5 } 
            });
            setPosts(response.data);
            console.log(posts);
            console.log(response)
          } catch (err) {
            console.error("Erro ao buscar posts:", err);
          }
        }
    
        fetchPosts();
    }, []);
  
    useEffect(() => {
      axios.get(`https://api.sigmasystems.com.br/api/odontoluzzi/get-servicos`)
        .then((response) => {
            const data = response.data;

            if (Array.isArray(data)) {
                const sorted = [...data].sort((a, b) => a.ordem - b.ordem);
                setServicos(sorted);
            }
        })
        .catch((error) => {
          console.error('Erro na requisição:', error);
        });
        
    },[servicoName]);
    const handleClick = (servicoName) => {
        navigate(`/Especialidades/${servicoName}`);
    };

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const scrollRef = useRef(null);

    const scrollLeft = () => {
        scrollRef.current.scrollBy({ left: -300, behavior: 'smooth' });
    };

    const scrollRight = () => {
        scrollRef.current.scrollBy({ left: 300, behavior: 'smooth' });
    };


    
    return (
        <div className="container">
            <Header/>
            <div className="content">
                
                <div className="banner">
                    <div className="bannerContent">
                        <div className="bannerLeft from-left">
                            <Typography className='bsubtitle' style={{fontFamily:'Inter', color:'#fff', marginBottom:'40px'}}>BEM VINDO(A) À ODONTO LUZZI</Typography>
                            <Typography className='bchamada' variant="h4" sx={{ fontFamily:'Inter',color: 'white', fontWeight: 'bold', fontSize:'56px', marginBottom:'20px' }}>
                            <span style={{ color: '#B08E44' }}>Sorria</span> com confiança <br/> na <span style={{ color: '#B08E44' }}>Odonto Luzzi</span>
                            </Typography>
                            <Typography sx={{marginBottom:'30px', fontFamily:'Inter', color:'#fff', fontSize:'20px'}}>Tratamentos modernos, atendimento humanizado e <br/>resultados que transformam sorrisos.</Typography>
                            <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}>
                                <Button sx={{marginBottom:'10px', paddingInline:'25px', height:45, borderRadius:'5px', color:'#041819', fontSize:'15px', fontWeight:'bold', backgroundColor:'#fff', textTransform: 'none','&:hover': {color: '#B08E44'}}}>Agendar Avaliação</Button>
                            </a>
                            <Typography sx={{marginBottom:'30px', fontFamily:'Inter', color:'#fff', fontSize:'16px'}}>+ de 1000 sorrisos transformados</Typography>
                            <div>
                                <a href='https://instagram.com/odontoluzzi' style={{textDecoration:'none', color:'#000', marginRight:'6px'}}><InstagramIcon sx={{ backgroundColor:'#fff', padding:'5px', borderRadius:'5px',fontSize:32, color:'#041819', cursor:'pointer', '&:hover':{color:'#B08E44'}}}/></a>
                                <a href='https://www.facebook.com/profile.php?id=100063743283039' style={{textDecoration:'none', color:'#000', marginInline:'6px'}}><FacebookRoundedIcon sx={{backgroundColor:'#fff', padding:'5px', borderRadius:'5px', fontSize:32, color:'#041819', '&:hover':{color:'#B08E44'}}}/></a>
                                <a href='https://wa.me/+554532252800' style={{textDecoration:'none', color:'#000', marginLeft:'6px'}}><WhatsAppIcon sx={{backgroundColor:'#fff', padding:'5px', borderRadius:'5px', fontSize:32, color:'#041819', '&:hover':{color:'#B08E44'}}}/></a>
                            </div>
                        </div>
                        <div className="bannerRight from-right">
                            <img src="https://odontoluzzi.com.br/images/photoBanner1.png" className="photoBanner1"/>
                        </div>
                    </div>
                </div>
                <div className="servHomeContainer">
                    <div className="servHomeContent">
                        <div className="servHomeTopo">
                            <div className="servHomeLeft from-left">
                                <div className="subTitle">Serviços</div>
                                <div className="title">Conheça os<br/>nossos serviços</div>
                            </div>
                            <div className="servHomeRight from-right">
                                <div>Temos os melhores equipamentos do mercado para oferecer
                                o melhor atendimento aos nossos pacientes.</div>
                            </div>
                        </div>
                        <div className="servHomeDown from-right">
                            <div>
                                <img src="https://odontoluzzi.com.br/images/arrowLeft.svg" className="arrowLeft" alt="arrowLeft" onClick={scrollLeft}/>
                                <img src="https://odontoluzzi.com.br/images/arrowRight.svg" className="arrowRight" alt="arrowRight" onClick={scrollRight}/>
                            </div>
                            
                        </div>
                        <Box sx={{ width: '100%', position: 'relative' }} className=' from-bottom'>
                            
                            <Box
                                ref={scrollRef}
                                sx={{
                                display: 'flex',
                                overflowX: 'auto',
                                scrollBehavior: 'smooth',
                                gap: 2,
                                pb: 1,
                                
                                }}
                            >
                                {servicos.map((servico, index) => (
                                    <EspecialidadeCard key={index} title={servico.name} text={servico.descricao} img={servico.foto ? `https://api.sigmasystems.com.br/api/odontoluzzi/uploads/especialidades/${servico.foto}` : 'https://odontoluzzi.com.br/images/padrao/padraoServico.png'} onClick={() => handleClick(servico.name)}/>
                                ))}
                                
                                
                            </Box>
                        </Box>
                        
                    </div>
                </div>
                <div className="ourHistory">
                    <div className="ourHistoryContent">
                        <div className="ourHistoryLeft from-left">
                            <div className="subTitle from-left" style={{color:'#FFF', marginBottom:'5px'}}>Nossa História</div>
                            <div className="ourHistoryTitle from-left">
                                
                                <span style={{color:'#B08E44'}}>Conheça</span> um pouco da nossa <span style={{color:'#B08E44'}}>história.</span>
                            </div>
                            <div className="ourHistoryLine from-left"/>
                            <img src="https://odontoluzzi.com.br/images/recepcao.png" className="recepcaoImg" alt="recepcao"/>
                        </div>
                        <div className="ourHistoryRight from-right">
                            <Box
                                className='imageVideo'
                                sx={{
                                position: 'relative',
                                backgroundImage: 'url("/images/recepcao.png")',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                borderRadius: 2,
                                cursor: 'pointer',
                                boxShadow: 3
                                }}
                                onClick={handleOpen}
                                
                            >
                                <IconButton
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    backgroundColor: 'rgba(255,255,255,0.7)',
                                    color: '#000',
                                    '&:hover': {
                                    backgroundColor: 'rgba(255,255,255,0.9)',
                                    },
                                    width: 64,
                                    height: 64,
                                    borderRadius: '50%',
                                }}
                                >
                                <PlayArrowIcon fontSize="large" />
                                </IconButton>
                            </Box>
                            <Modal open={open} onClose={handleClose}>
                                <Box
                                className='videoHome'
                                sx={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '49%',
                                    transform: 'translate(-50%, -50%)',
                                    bgcolor: 'background.paper',
                                    boxShadow: 24,
                                    outline: 'none',
                                    
                                }}
                                >
                                <iframe
                                    width="100%"
                                    height="100%"
                                    src="https://www.youtube.com/embed/AKeUssuu3Is?controls=1&modestbranding=1&rel=0&showinfo=0"
                                    title="Vídeo"
                                    frameBorder="0"
                                    allow="autoplay; encrypted-media"
                                    allowFullScreen
                                />
                                </Box>
                            </Modal>
                            <div className='ourHistoryText from-right'>A Odonto Luzzi nasceu do sonho de levar um atendimento odontológico diferenciado, onde tecnologia, empatia e profissionalismo caminham juntos. Fundada por profissionais apaixonados por transformar vidas através do sorriso, nossa clínica vem se consolidando como referência em cuidado e confiança.</div>
                            <div className="ourHistoryLine from-right"/>
                        </div>
                    </div>
                </div>
                <div className="depoContainer">
                    <img src="https://odontoluzzi.com.br/images/pattern.svg" className="patternL"/>
                    <img src="https://odontoluzzi.com.br/images/pattern.svg" className="patternR"/>
                    <div className="depoContent">
                        <div className="subTitle from-bottom">Depoimentos</div>
                        <div className="title depo from-bottom">Alguns de nossos depoimentos</div>
                        <div className="titleLine from-bottom"/>
                        
                        <Grid2  container spacing={4} justifyContent={'center'} className=' from-bottom' >
                            <Grid2 item>
                                <div className="depoCardContainer">
                                    <div className='depoCardFoto'>H</div>
                                    <div className="depoCardText">
                                        <div className="depoCardName">Heber</div>
                                        Encontrei Odonto Luzz pela Internet,foi um grande achado! Uma equipe maravilhosa,o Dr Evandro,muito atencioso,juntamente com sua amável equipe,me identifiquei logo e estou muito feliz com o atendimento da família Luzzi.
                                        <div className="depoStars">
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                        </div>
                                    </div>
                                    <img src='./images/aspas.svg' className='aspasUp'/>
                                    <img src='./images/aspas.svg' className='aspasDown'/>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="depoCardContainer">
                                    <div className='depoCardFoto'>E</div>
                                    <div className="depoCardText">
                                        <div className="depoCardName">Eliane Mattos</div>
                                        Que Clínica Incrível, ambiente lindo, organizado e com muita tecnologia para garantir o melhor resultado! Os Profissionais são maravilhosos, super solícitos e tornam todo o processo muito leve, time todo foi sensacional em todas etapas do atendimento, muito cuidado e atenção no tratamento, sempre preocupados com o bem estar. Super recomendo!
                                        <div className="depoStars">
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                        </div>
                                    </div>
                                    <img src='./images/aspas.svg' className='aspasUp'/>
                                    <img src='./images/aspas.svg' className='aspasDown'/>
                                </div>
                            </Grid2>
                            <Grid2 item>
                                <div className="depoCardContainer">
                                    <div className='depoCardFoto'>F</div>
                                    <div className="depoCardText">
                                        <div className="depoCardName">Fernanda Luisa Guaitanelly Heringer</div>
                                        Foi a melhor experiência que eu já tive com dentista. Sempre senti muita dor e tinha pavor de ir ao dentista. Quando cheguei ao consultório fui muito bem recepcionada por todos que trabalham ali. A experiência com a Dra Luana Dupont então foi maravilhosa. Além dela ser extremamente querida e inteligente, me transmitiu muita confiança. Tratamento diferenciado e qualidade no que entregam. Eu amei.
                                        <div className="depoStars">
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                            <StarRoundedIcon sx={{color:'#B08E44'}}/>
                                        </div>
                                    </div>
                                    <img src='./images/aspas.svg' className='aspasUp'/>
                                    <img src='./images/aspas.svg' className='aspasDown'/>
                                </div>
                            </Grid2>
                        </Grid2>                            
                        
                    </div>
                </div>
                <div className="workContainer">
                    <div className="workContent from-bottom">
                        <div className="title" style={{color:'#fff'}}>Trabalhe Conosco</div>
                        <div className="titleLine"/>
                        <div className="workSubTitle">Venha fazer parte da nossa equipe!</div>
                        <div className="workLinks">
                            <a href='https://linkedin.com'><img src="https://odontoluzzi.com.br/images/linkedin.svg" className="linkedIn"/></a>
                            <a href='https://infojobs.com'><img src="https://odontoluzzi.com.br/images/ij.svg" className="infoJobs" style={{width:'33px'}}/></a>
                        </div>
                    </div>
                </div>
                {posts ? (
                <div className="feedContainer">
                    <div className="feedContent">
                        <div className="subTitle from-bottom" style={{color:'#fff'}}>Publicações</div>
                        <div className="title from-bottom">Veja algumas de nossas publicações</div>
                        <div className="titleLine from-bottom" style={{backgroundColor:'#fff'}}/>
                        
                        <div className="postsContainer from-bottom">
                            
                            <Grid2  container spacing={1} justifyContent={'center'} >
                            {posts.map((post) => (
                                <Grid2 item>
                                    
                                    {post.media_type === 'IMAGE' && (
                                        <img src={post.media_url} className="instaImg"/>
                                    )}
                                    {post.media_type === 'VIDEO' &&(
                                        <video className='instaVideo' controls>
                                            <source src={post.media_url}  type="video/mp4"/>Seu navegador não suporta vídeos.
                                        </video>
                                    )}
                                    {post.media_type === 'CAROUSEL_ALBUM' && (
                                        <img src={post.media_url} className="instaImg"/>
                                    )}
                                    
                                    
                                </Grid2>
                            ))}
                            </Grid2>
                        </div>
                        
                        <a href='https://instagram.com/odontoluzzi' style={{marginTop:'30px'}} className='from-bottom'>
                        <Button sx={{color:'#fff', height:50, width:162, borderRadius:'5px', border:'solid 2px #fff', fontSize:'15px', fontWeight:'bold', backgroundColor:'none', textTransform: 'none','&:hover': {color: '#B08E44', backgroundColor:'#fff'}}}>Ver mais</Button>
                        </a>
                    </div>
                </div>
                ):('')}
                <div className="mapContainer">
                    <div className="mapContent">
                        <div className="subTitle">Localização</div>
                        <div className="title">Onde Estamos</div>
                        <div className="titleLine"/>
                        <iframe className='map from-bottom' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.207059696882!2d-53.46348442384214!3d-24.959068914426737!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f3d413fff6f933%3A0x8df61cebf00b39bb!2sOdonto%20Luzzi%20-%20Luzzi%20Odontologia%20-%20Implante%20Dent%C3%A1rio%2C%20Clareamento%20Dental%2C%20Pr%C3%B3teses%2CAparelho%20Ortod%C3%B4ntico%2C%20Facetas%20em%20Cascavel!5e0!3m2!1spt-BR!2sbr!4v1755541546358!5m2!1spt-BR!2sbr" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> 
                    </div>
                </div>
                <Agendar/>
                
                
                
            </div>   
            <Footer/>
        </div>
    )
}
export default Home;